/**
 * Analytics Charts Page (Web)
 * Placeholder for analytics charts
 */

import { Container, Typography, Box } from '@mui/material';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';

export function AnalyticsChartsPage() {
  return (
    <AuthenticatedLayout>
      <Container maxWidth="lg">
        <Box sx={{ mt: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Analytics Charts
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Charts feature coming soon...
          </Typography>
        </Box>
      </Container>
    </AuthenticatedLayout>
  );
}

